import { render, staticRenderFns } from "./liveCourse.vue?vue&type=template&id=46362956&scoped=true"
import script from "./liveCourse.vue?vue&type=script&lang=ts"
export * from "./liveCourse.vue?vue&type=script&lang=ts"
import style0 from "./liveCourse.vue?vue&type=style&index=0&id=46362956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46362956",
  null
  
)

export default component.exports